export default __webpack_public_path__ + "bfc1bcee5eb3f0e3b434b3785bbac0ac.svg";